<template>
  <div class="main list-view logbooks-list">
	<div class="sub-header">
	  <div class="input-with-control">
		<input type="search" v-model="filters.search_term" placeholder="Search..." @search="doSearch()" v-focus/>
		<div class="button action input-go" @click="doSearch()"><i class="fas fa-search"></i></div>
	  </div>
	  <div class="controls">
		<pagination
		  v-if="showPagination"
		  :paging="paging"
		  @updatePage="goToPage"
		></pagination>
	  </div>
	</div>

	<div class="filters">
		<div v-if="showDetailForm">
			<div class="button neutral" @click="backToList()">Back to List</div>
			<div class="divider"></div>
			<div class="extra-menu-item" @click="confirmDelete = true">Delete Uploaded Form</div>
		</div>
		<div v-else>

			<div class="title">Filter by dates...</div>
			<div>
				<div class="label-group">
					<label>Start</label>
					<input type="date" v-model="filters.start_date" :max="$today().clone().format('YYYY-MM-DD')">
				</div>
				<div class="label-group">
					<label>End</label>
					<input type="date" v-model="filters.end_date" :max="$today().clone().format('YYYY-MM-DD')">
				</div>
				<div class="label-group">
					<label></label>
					<div class="checkbox-group">
						<span :class="['pointer', 'far', !filters.start_date && !filters.end_date ? 'disabled' : '', filters.use_date_uploaded ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('use_date_uploaded')"></span>
						<label>Uploaded</label>
						<span :class="['pointer', 'far', !filters.start_date && !filters.end_date ? 'disabled' : '', filters.use_date_transferred ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('use_date_transferred')"></span>
						<label>Transfered</label>
					</div>
				</div>
				<div class="label-group">
					<label></label>
					<div class="button small neutral" @click="setFilterDates()">Filter Dates</div>
				</div>
				<div class="divider"></div>
				<div class="button neutral" @click="clearFilters(true)">Clear Filters</div>
			</div>
			<div class="divider"></div>
			<div class="button primary action" @click="startNewForm = true">Upload A Form</div>
		</div>
	</div>

	<div v-if="!loading && !showDetailForm && logBookForms.length > 0" class="list report-list">
	  <table class="logbook-forms data-list" cellpadding="0" cellspacing="0">
		<thead>
		  <tr>
			<th>Uploaded</th>
			<th>Transferee</th>
			<th>Transfer Date</th>
			<th>TSN</th>
			<th>File Name</th>
			<th>File Type</th>
		  </tr>
		</thead>
		<tbody>
		  <tr
			class="list clickable-list-item"
			v-for="(item, index) in logBookForms"
		  >
			<td @click="goToDetail(item)">
			  {{ $moment(item.date_created).format("MM/DD/YYYY") }}
			</td>
			<td @click="goToDetail(item)">
			  {{ item.full_name }}
			</td>
			<td @click="goToDetail(item)">
			  {{
				item.transfer_date
				  ? $moment(item.transfer_date).format("MM/DD/YYYY")
				  : ""
			  }}
			</td>
			<td @click="goToDetail(item)">
			  {{ item.transaction_serial_number }}
			</td>
			<td @click="goToDetail(item)">
			  {{ item.file_name }}
			</td>
			<td @click="goToDetail(item)">
			  {{ item.file_type }}
			</td>
		  </tr>
		</tbody>
	  </table>
	</div>

	<div v-else-if="logBookForms.length == 0 && !loading && !showDetailForm" class="empty-list">
	  No uploaded forms found
	</div>

	<div v-if="showDetailForm" class="detail">
		<div class="three-columns">
			<div>
				<label>Transferee Full Name</label>
				<input type="text" v-model="detailForm.full_name" />
			</div>
			<div>
				<label>Transfer Date</label>
				<input type="date" v-model="detailForm.transfer_date" />
			</div>
			<div>
				<label>Transaction Serial Number</label>
				<input type="text" v-model="detailForm.transaction_serial_number" />
			</div>
			<div>
				<label>File Name</label>
				<input type="text" v-model="detailForm.file_name" readonly />
			</div>
		</div>
		<div style="width: 98%;">
			<div v-if="detailForm.file_url && detailForm.file_url != 'error'"> 
				<div class="right">
					<div v-if="detailForm.file_type == 'application/pdf'" class="button neutral" @click="downloadForm()">Download</div>
					<div v-else class="button neutral" @click="downloadImage()">Download</div>
				</div>
				<vue-pdf-embed v-if="detailForm.file_type == 'application/pdf'" :source="detailForm.file_url" ref="embedded_pdf"/>
				<img v-else :src="detailForm.file_url" style="width: auto; max-width: 100%; border: 1px solid #ccc;"/>
			</div>
		</div>
	</div>

	<div v-if="startNewForm" class="modal medium-modal">
	  <div class="inner" style="width: 60em;">
		<h2>Upload A Paper 4473</h2>
		<div class="content">
			<p>Enter the transferee's full name and optional transfer date, then upload a PDF or image of the paper form.</p>
			<div class="three-columns">
				<div>
					<label>Transferee Full Name</label>
					<input type="text" v-model="detailForm.full_name" />
					<label>Transfer Date</label>
					<input type="date" v-model="detailForm.transfer_date" />
					<label>Transaction Serial Number</label>
					<input type="text" v-model="detailForm.transaction_serial_number" />
				</div>
				<div>
					<vue-dropzone @vdropzone-file-added="filesFileAdded" @vdropzone-success="filesUploadSuccess" @vdropzone-error="filesUploadError" ref="filesDropzone" id="site_background_dropzone" :options="filesDropzoneOptions"></vue-dropzone>
					<label><em>Allowed file types: pdf, jpg, png</em></label>
				</div>
				<div class="dropzone dz-preview dz-file-preview uploaded-files" style="border: 0 none;"></div>
			</div>
			<p>{{ saveMessage }}</p>
		</div>
		<div class="controls">
		  <div class="button cancel spaced" @click="startNewForm = false">Cancel</div>
		  <div :class="['button', detailForm.full_name && detailForm.file_name ? 'action' : 'neutral', 'spaced']" @click="saveNewForm()">Save Uploaded Form</div>
		</div>
	  </div>
	</div>

	<div v-if="confirmDelete" class="modal">
	  <div class="inner" style="width: 60em;">
		<h2>Delete Uploaded 4473</h2>
		<div class="content">
			<p>Are you sure you want to delete this uploaded form?</p>
			<p>This action cannot be undone.</p>
			<p>{{ saveMessage }}</p>
		</div>
		<div class="controls">
		  <div class="button cancel spaced" @click="confirmDelete = false">Cancel</div>
		  <div :class="['button', detailForm.full_name && detailForm.file_name ? 'action' : 'neutral', 'spaced']" @click="deleteForm()">Delete Uploaded Form</div>
		</div>
	  </div>
	</div>

	<message-modal
	  v-if="message"
	  :message="message"
	  :loading="loading"
	  :errorStatus="messageStatus"
	  :timeout="messageTimeout"
	  @dismiss="message = ''"
	/>

	<iframe id="download" src="" style="display: none"></iframe>

  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

export default {
  name: "uploaded-paper-forms",
	components: {
		'vue-dropzone': vue2Dropzone,
		'vue-pdf-embed': VuePdfEmbed
	},
	data() {
		return {
			page: 1,
			showPagination: false,
			logBookForms: [],
			paging: {},
			filters: {},
			loading: false,
			message: "",
			messageStatus: "",
			messageTimeout: 0,
			startNewForm: false,
			showDetailForm: false,
			detailForm: {
				full_name: "",
				transfer_date: "",
				transaction_serial_number: "",
				file_name: "",
				file_type: ""
			},
			saving: false,
			saveMessage: "",
			showRouteFirstRequested: false,
			downloadMessage: "",
			downloadAlert: "",
			confirmDelete: false
		}
	},
	created() {
		this.clearFilters();
	},
	computed: {
		filesDropzoneOptions() {
			return {
				url: this.getApiEndpoint + '?action=upload_paper_form_4473',
				withCredentials: true,
				uploadMultiple: false,
				paramName: 'upload_file',
				maxFilesize: 4,
				createImageThumbnails: false,
				acceptedFiles: 'image/jpeg,image/png,application/pdf',
				previewsContainer: '.uploaded-files',
				params: {
					fd_token: this.$getCookie('dashboard_token'),
					source: 'LOGBOOKS'
				}
			}
		}
	},
	methods: {
		...mapActions("logbooks", ["updatePreference"]),
		getList() {
			if (this.loading) { return }
			this.loading = true;
			this.message = "Loading forms...";
			this.messageStatus = "waiting";
			this.apiCall({
				destination: "get_list_ffl_log_book_forms_uploaded",
				data: this.filters,
			}).then((obj) => {
				this.messageStatus = obj.status;
				this.loading = false;
				if (obj.status == "success") {
					this.message = "";
					this.logBookForms = obj.list;
					this.paging = obj.paging;
					this.showPagination = true;
				} else {
					this.message = obj.message;
				}
			}).catch((err) => {
				console.log(err);
				this.loading = false;
			})
		},
		doSearch() {
			this.filters.page = 1;
			this.getList()
		},
		today() {
			return this.$moment()
		},
		toggleFilter(which) {
			// use_date_uploaded and use_date_transferred are disabled without start or end date
			if (which == 'use_date_uploaded' || which == 'use_date_transferred') {
				if (!this.filters.start_date && !this.filters.end_date) {
					return false;
				}
				if (which == 'use_date_uploaded') {
					this.filters.use_date_transferred = false
				} else {
					this.filters.use_date_uploaded = false
				}
			}
			this.filters[which] = !this.filters[which]
			this.filters.page = 1
			this.getList()
		},
		setFilterDates() {
			this.filters.page = 1
			this.getList()
		},
		goToDetail(item) {
			this.loading = true;
			this.message = "Loading form details...";
			this.apiCall({
				destination: "get_item_ffl_log_book_forms_uploaded",
				data: { ffl_log_book_forms_uploaded_id: item.ffl_log_book_forms_uploaded_id },
			}).then((obj) => {
				this.loading = false;
				this.message = obj.message;
				this.messageStatus = obj.status;
				if (obj.status == "success") {
					this.detailForm = obj.item;
					this.showDetailForm = true;
				} else {
					this.message = obj.message;
				}
			}).catch((err) => {
				console.log(err);
				this.saving = false;
			})
		},
		goToPage(page) {
			this.filters.page = page;
			this.getList()
		},
		clearFilters() {
			this.filters = {
				page: 1,
				search_term: "",
				start_date: "",
				end_date: "",
				use_date_uploaded: false,
				use_date_transferred: true
			}
			this.getList()
		},
		filesUploadSuccess(file, response) {
			var obj = JSON.parse(response)
			if (obj.status != 'success') {
				this.saveMessage = obj.message
			} else {
				this.detailForm.file_name = obj.file_name
				this.detailForm.file_type = obj.file_type
			}
		},
		filesUploadError(file, message, xhr) {
			this.saveMessage = message
		},
		filesFileAdded(file) {
			// this.savingForm = true
			// this.filesAdded++
		},
		async downloadImage() {
			const response = await fetch(this.detailForm.file_url)
			const blob = await response.blob()
			const blobUrl = URL.createObjectURL(blob)
			const link = document.createElement('a')
			link.href = blobUrl
			link.download = this.detailForm.file_name
			link.click()
			URL.revokeObjectURL(blobUrl)
		},
		downloadForm() {
			if (!this.detailForm.file_url || this.detailForm.file_url == 'error') {
				console.log("No valid file to download.");
				return;
			}
			if (this.$refs.embedded_pdf) {
				this.$refs.embedded_pdf.download();
			} else {
				console.log("File is not available for download.");
			}
		},
		saveNewForm() {
			if (this.saving) { return }
			if (!this.detailForm.full_name || !this.detailForm.file_name) {
				this.message = "Please enter the transferee's full name and upload a file.";
				this.messageStatus = "error";
				return;
			}
			this.saving = true;
			this.saveMessage = "Saving uploaded form...";
			this.apiCall({
				destination: "save_item_ffl_log_book_forms_uploaded",
				data: this.detailForm,
			}).then((obj) => {
				this.saving = false;
				if (obj.status == "success") {
					this.saveMessage = "Uploaded form saved successfully!";
					setTimeout(() => {
						this.startNewForm = false;
						this.saveMessage = "";
						this.detailForm = {
							full_name: "",
							transfer_date: "",
							transaction_serial_number: "",
							file_name: "",
							file_type: ""
						}
						this.getList()
					}, 1500)
				} else {
					this.saveMessage = obj.message;
				}
			}).catch((err) => {
				console.log(err);
				this.saving = false;
			})
		},
		deleteForm() {
			if (this.saving) { return }
			this.saving = true;
			this.saveMessage = "Deleting uploaded form...";
			this.apiCall({
				destination: "delete_item_ffl_log_book_forms_uploaded",
				data: { ffl_log_book_forms_uploaded_id: this.detailForm.ffl_log_book_forms_uploaded_id },
			}).then((obj) => {
				this.saving = false;
				if (obj.status == "success") {
					this.saveMessage = "Uploaded form deleted successfully!";
					setTimeout(() => {
						this.confirmDelete = false;
						this.saveMessage = "";
						this.showDetailForm = false;
						this.detailForm = {
							full_name: "",
							transfer_date: "",
							transaction_serial_number: "",
							file_name: "",
							file_type: ""
						}
						this.getList()
					}, 1500)
				} else {
					this.saveMessage = obj.message || "An error occurred while deleting the form.";
				}
			}).catch((err) => {
				console.log(err);
				this.saving = false;
			})
		},
		backToList() {
			this.showDetailForm = false;
			this.detailForm = {
				full_name: "",
				transfer_date: "",
				transaction_serial_number: "",
				file_name: "",
				file_type: ""
			}
		}
	}
}
</script>
